<pos-app-spinner [show]="(loadingCustomerDetails$ | async) || (loadingFetchingOrderFromJDE$ | async)"></pos-app-spinner>

<div
  class="container-fluid max1200"
  *ngIf="{
    isExternalUser: isExternalUser$ | async,
    brandDefaults: brandDefaults$ | async,
    isProgrammeUser: isProgrammeUser$ | async
  } as data"
>
  <ng-container>
    <div>
      <app-customers-nav
        [activeOrder]="activeOrder$ | async"
        [selectedCustomer]="selectedCustomer"
        [isExternalUser]="data.isExternalUser"
        [securityFunctions]="securityFunctions"
        [isProgrammeUser]="data.isProgrammeUser"
        [isGenericQuotesOnlyTF] ="isGenericQuotesOnlyTF"
        [showExternal]="isShowExternalUser"
        [arbCentralSecurityFunctions]="arbCentralSecurityFunctions$ | async"
      ></app-customers-nav>
      <hr />
    </div>

    <div *ngIf="selectedCustomer" class="card shadow-sm">
      <div class="card-body p-4">
        <app-customer-details-view
          [customer]="selectedCustomer"
          [sales]="customerSales$ | async"
          [isExternal]="data.isExternalUser"
          [isProgrammeUser]="data.isProgrammeUser"
          [selectedCustomer]="selectedCustomer"
          [loadingCustomerSalesDetails$]="loadingCustomerSalesDetails$"
        ></app-customer-details-view>
      </div>
    </div>

    <div class="pt-4" *ngIf="selectedCustomer || newCustomer.isActive">
      <router-outlet></router-outlet>
    </div>
  </ng-container>
</div>

<a routerLink="/pos/customers/new" routerLinkActive #newCustomer="routerLinkActive"> </a>
